

import { Component, Mixins, Prop, Watch, Emit } from "vue-property-decorator";
import GlobalMixin from "@/mixins/global";
import { DialogVariant } from './types';
import IBSVGIconClose from "@/components/SVGIcon/IBSVGIconClose.vue";
import IBSVGIconChevronLeft from "@/components/SVGIcon/IBSVGIconChevronLeft.vue";
import TestProps from "@/mixins/test/TestProps";
import { Properties } from 'csstype';

@Component({
	components: {
		IBSVGIconClose,
		IBSVGIconChevronLeft
	}
})
export default class IBDialog extends Mixins(
	GlobalMixin,
	TestProps
) {

	@Prop({ type: Boolean, default: false })
	readonly value!: boolean;

	@Prop({ type: String, default: "" })
	readonly title!: string;

	@Prop({ type: String, default: "" })
	readonly btnText!: string;

	@Prop({ type: String, default: "" })
	readonly btnPrependImgUrl!: string;

	@Prop({ type: Boolean, default: false })
	readonly withCloseBtn!: boolean;

	@Prop({ type: Boolean, default: false })
	readonly persistent!: boolean;

	@Prop({ type: Boolean, default: false })
	readonly showOverflow!: boolean;

	@Prop({ type: Boolean, default: true })
	readonly mobileActionsVisible!: boolean;

	@Prop({ type: Boolean, default: false })
	readonly btnDisabled!: boolean;

	@Prop({ type: Boolean, default: false })
	readonly hideFooter!: boolean;

	@Prop({ type: Boolean, default: true })
	readonly isModal!: boolean;

	@Prop({ type: [ Object, String ], default: "" })
	readonly bodyClass!: string | Object;

	@Prop({ type: [ String, Number ], default: 526 })
	readonly width!: string | number;

	@Prop({ type: Boolean, default: false })
	readonly noBackHandler!: boolean;

	@Prop({ type: Boolean, default: false })
	readonly showBack!: boolean;

	@Prop(Boolean)
	readonly blurBg?: boolean

	@Prop(String)
	readonly variant?: DialogVariant

	@Prop(String)
	readonly closeButtonTestId?: string

	@Prop(Number)
	readonly transitionDuration?: number

	public dialogActiveClass: string = "dialog--active";

	public cantClose: boolean = false;

	public persistentAnimTime: number = 70;

	public created() {
		this.setDialogActiveState();
	}

	public setDialogActiveState() {
		document.body.classList[this.value ? "add" : "remove"](this.dialogActiveClass);
	}

	public closeDialogGivenPersistent() {
		if (!this.persistent) {
			this.closeDialog();
		} else {
			this.cantClose = true;

			setTimeout(() => this.cantClose = false, this.persistentAnimTime);
		}
	}

	confirmAction() {
		if (!this.btnDisabled) this.emitConfirmed();
	}

	onBackClick() {
		this.noBackHandler
			? this.emitBackClick()
			: this.closeDialog();
	}

	get realWidth(): string {
		return (typeof this.width == "number")
			? this.width + "px"
			: this.width;
	}

	get transitionStyle(): Properties {
		return typeof this.transitionDuration === 'number'
			? { transitionDuration: `${this.transitionDuration}ms` }
			: {};
	}

	get transitionContentStyle(): Properties {
		return typeof this.transitionDuration === 'number'
			? { transitionDuration: `${this.transitionDuration + 100}ms` }
			: {};
	}

	@Watch("value")
	isActiveUpdated() {
		this.setDialogActiveState();
	}

	@Emit("input")
	closeDialog() {
		this.emitClose();

		return false;
	}

	@Emit("confirmed")
	emitConfirmed() {}

	@Emit('close')
	emitClose() {}

	@Emit('click:back')
	emitBackClick() {}

}

